import { forwardRef, type Ref, type SVGProps } from "react";
const IconRateVeryUnhappyFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2A14 14 0 1 1 2 16 14 14 0 0 1 16 2m0 16a8.48 8.48 0 0 0-5.71 2.29 1 1 0 0 0 1.42 1.42 6.24 6.24 0 0 1 8.58 0 1 1 0 0 0 1.42-1.42A8.48 8.48 0 0 0 16 18m-4-7a2 2 0 1 0 2 2 2 2 0 0 0-2-2m8 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2" />
  </svg>
);
const ForwardRef = forwardRef(IconRateVeryUnhappyFilledSVG);
ForwardRef.displayName = "IconRateVeryUnhappyFilled";
export { ForwardRef as IconRateVeryUnhappyFilled };
